export enum AdminLevel {
  Global = 'global',
  Account = 'account',
  Company = 'company',
}

export enum AdminRole {
  Developer = 'developer',
  SystemAdmin = 'system',
  PermissionManager = 'permission_manager',
  Admin = 'admin',
  EnrollmentManager = 'enrollment_manager',
  UserManager = 'user_manager',
  SalesManager = 'sales_manager',
  Salesperson = 'sales_person',
  LicenseManager = 'license_manager',
  CourseManager = 'course_manager',
  Approver = 'approver',
  AccountManager = 'account_manager',
  AccountOwner = 'account_owner',
}

export type AdminAbility =
  | 'munio.developer'
  | 'munio'
  | 'developer'
  | 'system'
  | 'global'
  | 'accounts'
  | 'admin'
  | 'approvals'
  | 'companies'
  | 'companies.edit'
  | 'courses'
  | 'courses.edit'
  | 'enrollment'
  | 'market'
  | 'permissions'
  | 'products'
  | 'products.edit'
  | 'reports'
  | 'roles'
  | 'sales'
  | 'sales.all'
  | 'users'
  | 'users.edit'
  | 'users.toggle_lock'

/**
 * Check if user has ability
 */
export function can(
  ability: AdminAbility,
  level: AdminLevel = AdminLevel.Company,
): boolean {
  if (!window.Munio.config.user.permissions) {
    return false
  }

  return !!(
    window.Munio.config.user.permissions[level]?.abilities[ability] ?? false
  )
}

window.Munio.can = can
